/**
 * Institution type options for the public BAA request form. Must stay in sync
 * with the INSTITUTION_TYPES validation list in functions/src/baa/index.js.
 */
export const INSTITUTION_TYPE_OPTIONS = [
  "Hospital or health system",
  "Physician practice or clinic",
  "Pharmacy",
  "School or school district",
  "Government or social services agency",
  "Other",
];
